import React from "react";
import { createRoot } from "react-dom/client";
import "@volkswagen-onehub/tokens/dist/css-vars.css";
import "./index.css";
import { AppWithAuth } from "./AppWithAuth";
import { ConfigContext } from "./context/ConfigContext";
import "systemjs/dist/s.js";
import "systemjs/dist/extras/named-register.js";
import "systemjs/dist/extras/amd.js";
import { Amplify } from "aws-amplify";
import { createApolloClient } from "./utils/apollo-client";
import { createLogger } from "./logger/HttpLogger";
import { getVersion } from "./getVersion";
import * as FeatureHubReact from "@feature-hub/react";
import * as ReactDOM from "react-dom";
import { defineExternals } from "@feature-hub/module-loader-amd";
const externals = {
    react: React,
    "react-dom": ReactDOM,
    "@feature-hub/react": FeatureHubReact,
};
fetch("/config.json")
    .then((res) => res.json())
    .then((config) => {
    const logger = createLogger({
        env: config.envName,
        url: "https://logger.vwonehub.io",
        version: getVersion(),
    });
    Amplify.configure(config);
    defineExternals(externals);
    const client = createApolloClient(config);
    const root = createRoot(document.getElementById("root"));
    root.render(React.createElement(React.StrictMode, null,
        React.createElement(ConfigContext.Provider, { value: { config, client, logger } },
            React.createElement(AppWithAuth, null))));
})
    .catch((e) => console.error("startup of app failed", e));
